/* ── Account center layout (IncomeBazaar profile redesign) ── */
.layout {
  display: grid;
  grid-template-columns: 290px 1fr;
  gap: 16px;
  align-items: start;
}

.panel {
  background: var(--ib-panel);
  border: 1px solid var(--ib-line);
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(27, 37, 52, 0.05), 0 6px 18px rgba(120, 30, 30, 0.05);
}

.tnum {
  font-variant-numeric: tabular-nums lining-nums;
}

/* ── Left: profile summary card ── */
.pcard {
  padding: 20px 18px;
  text-align: center;
  margin-bottom: 14px;
}

.avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin: 0 auto 12px;
  display: grid;
  place-items: center;
  background: var(--ib-navy);
  color: #fff;
  font-family: var(--font-serif);
  font-size: 24px;
  font-weight: 700;
}

.pcardName {
  font-family: var(--font-serif);
  font-size: 18px;
  font-weight: 700;
  color: var(--ib-ink);
}

.pcardPan {
  font-size: 12px;
  color: var(--ib-faint);
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.04em;
  margin-top: 2px;
}

.kycBadge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 11px;
  background: var(--ib-good-soft);
  color: var(--ib-good);
  font-weight: 700;
  font-size: 12px;
  padding: 5px 11px;
  border-radius: 20px;
}

/* ── Left: section nav ── */
.snav {
  padding: 7px;
}

.snavBtn {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 11px;
  border: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;
  padding: 10px 12px;
  border-radius: 9px;
  font-weight: 600;
  font-size: 13.5px;
  color: var(--ib-ink);
  position: relative;
  font-family: inherit;
}

.snavBtn:hover {
  background: var(--ib-line-2);
}

.snavBtnActive,
.snavBtnActive:hover {
  background: var(--ib-red-soft);
  color: var(--ib-red);
}

.snavBtnActive::before {
  content: '';
  position: absolute;
  left: 0;
  top: 9px;
  bottom: 9px;
  width: 3px;
  border-radius: 3px;
  background: var(--ib-red);
}

.snavIc {
  width: 18px;
  text-align: center;
  opacity: 0.75;
}

.tag {
  margin-left: auto;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 20px;
  background: var(--ib-good-soft);
  color: var(--ib-good);
}

.tagWarn {
  background: #fdf3e0;
  color: var(--ib-amber);
}

.logout {
  margin-top: 6px;
  color: var(--ib-red);
  border-top: 1px solid var(--ib-line-2);
  border-radius: 0;
}

.logout:hover {
  background: var(--ib-red-soft);
}

/* ── Right: detail panel ── */
.detail {
  padding: 0;
  overflow: hidden;
}

.dhead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 18px 22px 14px;
  border-bottom: 1px solid var(--ib-line-2);
}

.dheadTitle {
  margin: 0;
  font-family: var(--font-serif);
  font-size: 18px;
  font-weight: 700;
  color: var(--ib-ink);
}

.editBtn {
  border: 1px solid var(--ib-line);
  background: var(--ib-panel);
  color: var(--ib-ink);
  font-weight: 700;
  font-size: 12.5px;
  padding: 7px 14px;
  border-radius: 8px;
}

.dbody {
  padding: 14px 22px 22px;
}

/* Identity rows (2-col grid of CardAttributes) */
.rows {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 26px;
}

.hint {
  font-size: 12.5px;
  color: var(--ib-muted);
  margin-top: 14px;
}

/* ── KYC completeness ── */
.completeness {
  display: flex;
  align-items: center;
  gap: 16px;
  background: var(--ib-good-soft);
  border: 1px solid #cfe8db;
  border-radius: 12px;
  padding: 14px 16px;
  margin: 6px 0 4px;
}

.ring {
  --p: 100;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  flex: none;
  display: grid;
  place-items: center;
  background: conic-gradient(var(--ib-good) calc(var(--p) * 1%), #cfe8db 0);
}

.ringInner {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--ib-panel);
  display: grid;
  place-items: center;
  font-size: 12.5px;
  font-weight: 800;
  color: var(--ib-good);
  font-variant-numeric: tabular-nums;
}

.complTitle {
  font-size: 14px;
  font-weight: 700;
  color: var(--ib-ink);
}

.complSub {
  margin: 2px 0 0;
  font-size: 12.5px;
  color: var(--ib-muted);
}

.checks {
  margin-top: 14px;
  display: grid;
  gap: 9px;
}

.check {
  display: flex;
  align-items: center;
  gap: 11px;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--ib-ink);
}

.dot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-size: 11px;
  font-weight: 900;
  flex: none;
}

.dotOk {
  background: var(--ib-good-soft);
  color: var(--ib-good);
}

.dotNo {
  background: #fdf3e0;
  color: var(--ib-amber);
}

.checkSt {
  margin-left: auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--ib-muted);
  font-variant-numeric: tabular-nums;
}

/* ── Bank & payouts ── */
.sectionLabel {
  font-size: 12px;
  color: var(--ib-muted);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.sectionHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 18px;
}

.acct {
  border: 1px solid var(--ib-line);
  border-radius: 12px;
  padding: 14px 16px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.addrow {
  display: flex;
  gap: 10px;
  margin-top: 14px;
  flex-wrap: wrap;
}

.selectedDepositAcnt {
  border: 1px solid var(--button-border-hover-color);
}

.btnRed {
  background: var(--ib-red);
  color: #fff;
  border: 1px solid var(--ib-red);
  font-weight: 700;
  font-size: 13px;
  padding: 9px 16px;
  border-radius: 8px;
}

.btnRed:hover {
  background: var(--ib-red-d);
}

/* ── Refer & earn ── */
.refcard {
  background: linear-gradient(135deg, var(--ib-navy), var(--ib-navy-2));
  color: #fff;
  border-radius: 12px;
  padding: 18px;
  margin-top: 6px;
}

.refLbl {
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #a9b6c6;
  font-weight: 700;
}

.refcode {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px dashed rgba(255, 255, 255, 0.25);
  border-radius: 10px;
  padding: 12px 14px;
  margin-top: 8px;
}

.refcodeVal {
  font-size: 18px;
  font-family: var(--font-serif);
  letter-spacing: 0.06em;
}

.refcodeBtn {
  border: 0;
  background: var(--ib-red);
  color: #fff;
  font-weight: 700;
  font-size: 12.5px;
  padding: 7px 14px;
  border-radius: 8px;
  cursor: pointer;
  font-family: inherit;
}

.refcodeBtn:hover {
  background: var(--ib-red-d);
}

.refstats {
  display: flex;
  gap: 26px;
  margin-top: 14px;
}

.refstat b {
  display: block;
  font-size: 20px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.refstat span {
  font-size: 11.5px;
  color: #a9b6c6;
}

/* ── Reports & FAQ tiles ── */
.reports {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 6px;
}

.rtile {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid var(--ib-line);
  border-radius: 10px;
  padding: 13px 14px;
  cursor: pointer;
  color: var(--ib-ink);
  text-decoration: none;
}

.rtile:hover {
  border-color: var(--ib-red);
}

.rtileIc {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: var(--ib-chip);
  display: grid;
  place-items: center;
  font-size: 17px;
  flex: none;
}

.rtile b {
  font-size: 13.5px;
  font-weight: 700;
}

.rtile p {
  margin: 2px 0 0;
  font-size: 12px;
  color: var(--ib-muted);
}

@media only screen and (max-width: 820px) {
  .layout {
    grid-template-columns: 1fr;
  }
}

@media only screen and (max-width: 560px) {
  .rows {
    grid-template-columns: 1fr;
  }

  .reports {
    grid-template-columns: 1fr;
  }
}
